<template>
	<div style="  background: #eeeeee;height: 100vh;">
  <div class="wrap">
    <van-sticky>
      <van-nav-bar title="提现记录" left-arrow @click-left="$router.go(-1)" />
    </van-sticky>
    <div class="walletTitle" style="margin-top: 10px;">提现记录</div>
    <!-- 列表 -->
    <van-list
      v-model="loading"
      :finished="finished"
      @load="onLoad"
      finished-text="没有更多了"
      class="recordList"
    >
      <div class="recordItem" v-for="(item,index) in list" :key="index">
        <div class="itemLeft" style="width: 100%;">
         
       <div class="itemMoney" style="display: flex;justify-content: space-between;" >
		   <div style="text-align: left;">
			   提现方式
			   <span v-show="item.type==1">银行卡</span>
			   <span v-show="item.type==2">支付宝</span>
			   <span v-show="item.type==3">微信</span>
		   </div>
		 <div style="text-align: right;">
			 <span v-show="item.status==0" style="color: #00AEFF;">待审核</span>
			 <span v-show="item.status==1" style="color: #3B6BFB;">已通过</span>
			 <span v-show="item.status==2" style="color: red;">已拒绝</span>
		 </div>
           
          </div> 
		  <div class="itemMoney">
		    提现金额:
		    <span>{{item.money}}</span>
		  </div>
		  <div class="itemMoney">
		    到账金额:
		    <span>{{item.reality_money}}</span>
		  </div>
        <!--  <div class="itemMoney" v-show="form.type==2">
            账单金额:
            <span>{{item.money}}元</span>
          </div> -->
   <!--    <div class="itemMoney">
         备注:
         <span>{{item.remark}}</span>
       </div> -->
	   <div class="itemMoney"> <span>时间:{{item.create_time}}</span></div>
        </div>
      </div>
    </van-list>
	</div>
  </div>
</template>

<script>
import { myAward, userdrawRecord,tconfigTransferList } from "@/api/personal";
export default {
  data() {
    return {
      balance: 0,
      loading: false,
      finished: true,
	  activeName:"1",
	  walletype:[],
      list: [],
      form: {
		  type:1,
        page: 1,
        pagesize: 10
      }
    };
  },
  created() {
    myAward().then(res => {
      this.balance = res.award_money;
    });
	tconfigTransferList().then(res => {
		this.walletype=res
    });
    this.onLoad();
  },
  methods: {
	  getactive(e){
		  this.form.type=e
		  this.form.page=1
		  // this.form.page=10
		  this.list=[]
		  this.onLoad();
	  },
    onLoad() {
      userdrawRecord(this.form).then(resp => {
        this.form.page++;
        let rows = resp.data;
        this.count = resp.count;
        this.loading = false;
        this.finished = false;
        if (rows == null || rows.length == 0) {
          this.finished = true;
          return;
        }
        this.list = this.list.concat(rows);
        if (this.list.length >= this.count) {
          this.finished = true;
        }
      });
    }
  }
};
</script>
<style lang='less' scoped>
.wrap {
  height: 100%;
  background: #eeeeee;
  .walletTop {
    width: 357px;
    height: 162.5px;
    background: url("../../assets/imgs/personal/walletBg.png") 0 0 no-repeat;
    background-size: 100% 100%;
    margin: 7.5px auto 8.5px;
    padding: 42px 0 0 19.5px;
    color: #fff;
    font-size: 13px;
    position: relative;
    box-sizing: border-box;
	.topTitler {
	  position: absolute;
	  right: 5px;
	  top: 50px;
	  background: #02ac36;
	  border-radius: 11.5px 0 0 11.5px;
	  padding: 5.5px 16px;
	}
    .topTitle {
      position: absolute;
      right: 5px;
      top: 15.5px;
      background: #02ac36;
      border-radius: 11.5px 0 0 11.5px;
      padding: 5.5px 16px;
    }
    .topNum {
      div {
        &:last-child {
          font-size: 25px;
          margin-top: 17px;
        }
      }
    }
  }
  .walletTitle {
    color: #343434;
    font-size: 15px;
    margin: 0 0 8.5px 18px;
  }
  .recordList {
    width: 345px;
    border-radius: 8px;
    background: #fff;
    box-sizing: border-box;
    padding: 0 13px;
    margin: 0 auto;
    .recordItem {
      display: flex;
      justify-content: space-between;
      color: #666666;
      padding: 14.5px 0 12.5px;
      border-bottom: 1px solid #c1c1c1;
      font-size: 13px;
      .itemtype {
        color: #343434;
      }
      .itemMoney {
        margin-top: 11.5px;
        span {
          color: #343434;
        }
      }
      .itemRight {
        text-align: right;
        .itemStatus {
          font-size: 16px;
        }
        .itemTime {
          margin-top: 10px;
        }
      }
    }
  }
}
</style>